import { SocialTab, SocialTabType } from '@/models/Social/Profile/social-tab';
import { BlockStruct } from '@/models/Blocks/block-struct';
//import { Guid } from '@/models/identify';
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";
import request from '@/Utilities/httpRequest';

export class SocialTabTemplates extends SocialTab {
    protected _structs: Array<TemplateStruct> = [];
    protected _nextpage: number|null = 1;
    protected _isLoading: boolean = false;

    protected _data(value: any){
        let structs    = value.structs ?? null;
        this._nextpage = (value.nextpage??null);
        if(structs && structs.length > 0){
            this._addStructs(structs);
        }
        let remains = value.remains ?? [];
        if(remains.length > 0){
            this._addRemains(value.remains ?? []);
        }
    }

    protected _addStructs(structs: any[]){
        structs.forEach(struct =>{
            let template = struct.template ?? null;
            let data     = struct.data ?? null;
            if(template && data){
                let l = new BlockStruct(template.struct,data);
                //l.blockName = this._getBlockName();
                l.key = 't'+(this._structs.length + 1);
                this._structs.push(l.getStruct(template.properties));
            }
        });
    }

    protected _addRemains(products: any[]){
        let screen = this.screen;
        if(products.length > 0){
            let temp: any[] = [];
            let line: any[]  = [];
            let props: {[key: string]: any} = {};
            let data: {[key: string]: any}  = {};
            let i = 0;
            products.forEach((elem) => {
                let id = `id${i}`;
                line.push([{type:'s',id: id}]);
                if(line.length >= (screen == 'big' ? 6 : 4)){
                    temp.push(line);
                    line = [];
                }
                props[id] = {grid: (screen == 'big' ? 12 : 16), gridW: (screen == 'big' ? 2 : 4), shape: 's'};
                data[id]  = elem;
                i++;
            });
            //Last line
            if(line.length > 0){
                temp.push(line);
            }
            let l = new BlockStruct(temp,data);
            //l.blockName = this._getBlockName();
            l.key = 't'+(this._structs.length + 1);
            this._structs.push(l.getStruct(props));
        }
    }

    public async nextPage() {
        let params = this._getParams();
        if(this._isLoading){
            return false;
        }
        if(this._url && this._nextpage && params){
            this._isLoading = true;
            let { data } = await request.post(this._url,params,false);
            this._data(data);
            this._isLoading = false;
        }
    }

    public hasNextPage(): boolean{
        return this._nextpage != null;
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public get screen(): string {
        let screen: number = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        return screen >= 1920 ? 'big' : 'small';
    }

    public hasContent(): boolean{
        return this._structs.length > 0;
    }

    protected _getParams(): any|undefined {
        if(this._nextpage === null){
            return undefined;
        }
        return {...this._params,...{page:this._nextpage,screen:this.screen}};
    }

    // protected _getBlockName(): string {
    //     return this._params && this._params.oti ? this._params.oti : null
    // }

    public getData():Array<TemplateStruct>{
        if(this._isLoading){
            let l = new BlockStruct([[['h']]],[]);
            l.skeleton = true;
            return [...this._structs,l.getStruct()];
        }
        return this._structs;
    }

    public get type(): SocialTabType{
        return SocialTabType.blocks;
    }
}